import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import vuetifyConfig from 'ipro-ui-kit-vuejs/src/plugins/vuetify.config.json';

Vue.use(Vuetify);

export default new Vuetify(vuetifyConfig);
